export const getStockQueryKey = () => ['stock'];
